// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-invitation-table .table-wrapper{margin-bottom:3rem!important}.user-invitation-table .table td,.user-invitation-table .table th{padding:1rem .75rem}.user-invitation-table .table td:first-child,.user-invitation-table .table th:first-child{padding-left:1.5rem}.user-invitation-table .table td:last-child,.user-invitation-table .table th:last-child{padding-right:1.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
